export default "__VITE_ASSET__Be0w_ENr__"